<app-page>
  <supply-monitoring-stats></supply-monitoring-stats>
</app-page>
